import BottomAppBar from "../components/BottomBar";
import LinkList from "../components/LinkList";
import Navigation from "../components/Navigation";

const Link = () => {
  return (
    <>
      <Navigation title={"LINKS"} appBarColor="orange" />
      <div className="fixed-layout-main">
        <div className="white-card my-2">
          <LinkList />
        </div>
      </div>

      <BottomAppBar />
    </>
  );
};

export default Link;
